import { buildMeetingsBucketDemoRow, emptyMeetingLoadBucket, generateMeetingsBucketMockRaw, sharePercent } from '@web/lib/demo/utils/meetingsBucketDemoUtils';
import { emptyMeetingsPlannedVsActualRawCounts, MEETINGS_PLANNED_VS_ACTUAL_KEYS } from '@workalizer/shared';
export var meetingsPlannedVsActualAnalytic = function (input) {
    var includeTeamMetrics = input.userId == null;
    var current = emptyMeetingsPlannedVsActualRawCounts();
    var previous = emptyMeetingsPlannedVsActualRawCounts();
    for (var _i = 0, MEETINGS_PLANNED_VS_ACTUAL_KEYS_1 = MEETINGS_PLANNED_VS_ACTUAL_KEYS; _i < MEETINGS_PLANNED_VS_ACTUAL_KEYS_1.length; _i++) {
        var key = MEETINGS_PLANNED_VS_ACTUAL_KEYS_1[_i];
        current[key] = generateMeetingsBucketMockRaw();
        previous[key] = generateMeetingsBucketMockRaw();
    }
    var currentTotal = MEETINGS_PLANNED_VS_ACTUAL_KEYS.reduce(function (sum, key) { return sum + current[key].meetingCount; }, 0);
    var previousTotal = MEETINGS_PLANNED_VS_ACTUAL_KEYS.reduce(function (sum, key) { return sum + previous[key].meetingCount; }, 0);
    return {
        rows: MEETINGS_PLANNED_VS_ACTUAL_KEYS.map(function (key) {
            var _a, _b;
            var curr = (_a = current[key]) !== null && _a !== void 0 ? _a : emptyMeetingLoadBucket();
            var prev = (_b = previous[key]) !== null && _b !== void 0 ? _b : emptyMeetingLoadBucket();
            return buildMeetingsBucketDemoRow(key, curr, prev, sharePercent(curr.meetingCount, currentTotal), sharePercent(prev.meetingCount, previousTotal), includeTeamMetrics);
        })
    };
};
